import React, { useState, useEffect } from 'react';
import './Toast.css';

let toastId = 0;

const Toast = ({ toasts, onRemove }) => {
  return (
    <div className="ga-toast-container">
      {toasts.map(toast => (
        <div key={toast.id} className={`ga-toast ga-toast-${toast.type}`}>
          <span>{toast.message}</span>
        </div>
      ))}
    </div>
  );
};

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = 'success') => {
    const id = ++toastId;
    const newToast = { id, message, type };
    
    setToasts(prev => [...prev, newToast]);
    
    // Auto-remove after 4 seconds
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, 4000);
  };

  // Make showToast available globally for URL parameter handling
  useEffect(() => {
    window.showToast = showToast;
    return () => {
      delete window.showToast;
    };
  }, []);

  return { toasts, showToast };
};

export default Toast;